import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { ColorModeContext } from '../../theme/ColorModeContext';
import IconButton from '@mui/material/IconButton';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import { toggleColorModeStyles } from './toggleColorModeStyles';

export const ToggleColorMode = () => {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);
  const isDark = theme.palette.mode === 'dark';
  const isDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const classes = toggleColorModeStyles(isDark, isDownMd);
  return (
    <Box sx={classes.container}>
      <Tooltip title='Switch Color Mode' placement='bottom' sx={classes.ball}>
        <IconButton onClick={colorMode.toggleColorMode} color='inherit'>
          {theme.palette.mode === 'dark' ? (
            <DarkModeIcon />
          ) : (
            <WbSunnyRoundedIcon />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
